import ButtonLoadingContent from '../../../shared/Loading/ButtonLoadingContent';
import Lens from '../../../shared/Icons/Lens';

const Toolbar = ({
  mode,
  query,
  setQuery,
  editable,
  loadingUpdate,
  deleteChange,
  handleSaveAllScores,
}) => {
  if (mode !== 'principal') return null;
  return (
    <div className="p-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-b">
      <div className="relative w-full sm:w-80 max-w-sm">
        <Lens/>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar por nombre"
          className="w-full border border-gray-300 pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          disabled={loadingUpdate}
        />
      </div>
      {editable && (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <button
            onClick={deleteChange}
            className={`relative w-full max-w-sm sm:w-auto sm:max-w-xs text-white px-4 py-2 text-sm border border-transparent rounded min-w-[200px]
              ${loadingUpdate
                ? 'bg-purple-200 cursor-not-allowed'
                : 'bg-personalized hover:bg-white hover:text-personalized hover:border-personalized'}`}
          >
            <ButtonLoadingContent loading={loadingUpdate}>Deshacer Cambios</ButtonLoadingContent>
          </button>
          <button
            onClick={handleSaveAllScores}
            className={`relative w-full max-w-sm sm:w-auto sm:max-w-xs text-white px-4 py-2 text-sm border border-transparent rounded min-w-[200px]
              ${loadingUpdate
                ? 'bg-purple-200 cursor-not-allowed'
                : 'bg-personalized hover:bg-white hover:text-personalized hover:border-personalized'}`}
            disabled={loadingUpdate}
          >
            <ButtonLoadingContent loading={loadingUpdate}>Actualizar Puntajes</ButtonLoadingContent>
          </button>
        </div>
      )}
    </div>
  );
};

export default Toolbar;
